(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{if(event.target.matches('[data-sort]'))event.target.form.requestSubmit();});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"]) return;
  try {
    
const initCompactHeader = () => {
  const section = document.getElementById('shopify-section-custom-header');
  if (!section || section.dataset.stickyBound) return;
  section.dataset.stickyBound = 'true';
  const banner = section.querySelector('.announcement');
  const toggle = section.querySelector('.announcement-toggle');
  toggle?.addEventListener('click', () => {
    const paused = banner.classList.toggle('is-paused');
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
  });
  let queued = false;
  const update = () => {
    if (window.scrollY > 80) section.classList.add('is-compact');
    else if (window.scrollY < 30) section.classList.remove('is-compact');
    queued = false;
  };
  window.addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }, { passive: true });
  section.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = section.querySelector('.mobile-nav[open], .dropdown[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  });
  update();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCompactHeader, { once: true });
else initCompactHeader();
document.addEventListener('shopify:section:load', initCompactHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zarrii-slideshow'))customElements.define('zarrii-slideshow',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};this.slides=Array.from(this.querySelectorAll('[data-slide]'));this.dots=Array.from(this.querySelectorAll('[data-dot]'));this.index=0;this.paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovered=false;this.focused=false;this.editor=false;
  this.querySelector('[data-prev]')?.addEventListener('click',()=>this.show(this.index-1),opts);this.querySelector('[data-next]')?.addEventListener('click',()=>this.show(this.index+1),opts);this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.show(i),opts));
  this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},opts);this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},opts);this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},opts);this.addEventListener('focusout',e=>{this.focused=this.contains(e.relatedTarget);this.schedule();},opts);document.addEventListener('visibilitychange',()=>this.schedule(),opts);
  this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();this.show(this.index-1);}if(e.key==='ArrowRight'){e.preventDefault();this.show(this.index+1);}},opts);
  this.addEventListener('touchstart',e=>{this.startX=e.changedTouches[0].clientX;this.startY=e.changedTouches[0].clientY;},{...opts,passive:true});this.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-this.startX,dy=e.changedTouches[0].clientY-this.startY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));},{...opts,passive:true});
  this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.editor=true;this.show(i);}},opts);this.addEventListener('shopify:block:deselect',()=>{this.editor=false;this.schedule();},opts);this.schedule();
 }
 show(i){if(!this.slides.length)return;this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((slide,n)=>{slide.classList.toggle('is-active',n===this.index);slide.setAttribute('aria-hidden',String(n!==this.index));});this.dots.forEach((dot,n)=>dot.setAttribute('aria-pressed',String(n===this.index)));const active=this.slides[this.index],link=this.querySelector('[data-collection-link]');if(link){link.href=active.dataset.link;link.textContent=active.dataset.label;}this.schedule();}
 schedule(){clearTimeout(this.timer);if(this.slides.length>1&&!this.paused&&!this.hovered&&!this.focused&&!this.editor&&!document.hidden)this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.speed||5)*1000);}
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product"] && !Shopify.designMode) return;
  try {
    
if (!window.zarriiProductAvailabilityBound) {
  window.zarriiProductAvailabilityBound = true;
  document.addEventListener('change', event => {
    if (!event.target.matches('.zarrii-product select[name="id"]')) return;
    const select = event.target;
    select.closest('.zarrii-product').querySelectorAll('[data-variant-price]').forEach(price => { price.hidden = price.dataset.variantPrice !== select.value; });
    const available = select.selectedOptions[0]?.dataset.available === 'true' && select.form.dataset.bundleAllowed !== 'false';
    const form = select.form;
    form.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = !available; });
    const add = form.querySelector('button[name="add"]');
    if (add) add.textContent = available ? add.dataset.addLabel : add.dataset.soldOutLabel;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zarrii-bundles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zarrii-bundle-shop')) {
  customElements.define('zarrii-bundle-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const filters = Array.from(this.querySelectorAll('[data-size]'));
      const cards = Array.from(this.querySelectorAll('[data-count]'));
      const activate = button => {
        filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        cards.forEach(card => { card.hidden = card.dataset.count !== button.dataset.size; });
        const status = this.querySelector('.zb-filter-status');
        status.textContent = button.textContent.trim();
      };
      filters.forEach(button => button.addEventListener('click', () => activate(button)));
      const requested = new URLSearchParams(location.search).get('bundle_size');
      const initial = filters.find(button => button.dataset.size === requested) || filters[0];
      if (initial) activate(initial);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-count]');
        if (card) { const button = filters.find(filter => filter.dataset.size === card.dataset.count); if (button) activate(button); }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zarrii-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zarrii-recommendations')) {
  customElements.define('zarrii-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        fetch(this.dataset.url)
          .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
          .then(text => {
            if (!this.isConnected) return;
            const page = new DOMParser().parseFromString(text, 'text/html');
            const content = page.querySelector('zarrii-recommendations');
            if (content && content.querySelector('.zarrii-recommendations__item')) this.innerHTML = content.innerHTML;
          })
          .catch(() => {});
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
